import { LoadingButton } from "@mui/lab";
import { Alert, Divider, Stack, TextField, Typography } from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { ErrorDetailContainer } from "../../../api/config";
import { AccountService, OtpType } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";

export default function FreezeAccountDialog() {
    const { closeDialog } = useContext(DialogContext);

    const [otpCode, setOtpCode] = useState("");
    const [verificationCodeSent, setVerificationCodeSent] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [requestInProgress, setRequestInProgress] = useState(false);

    const sendVerificationCode = () => {
        setRequestInProgress(true);
        setError(null);
        AccountService.sendOtp("1", {
            otpType: OtpType.FREEZE_ACCOUNT,
        })
            .then((r) => {
                setVerificationCodeSent(true);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const handleCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
        setOtpCode(event.target.value);
    };

    const applyFreezeAccount = () => {
        setRequestInProgress(true);
        AccountService.freezeAccount("1", {
            otpCode: otpCode,
        })
            .then((r) => {
                window.location.reload();
            })
            .catch((e: ErrorDetailContainer) => {
                if (e.hasError("FreezeViolation")) {
                    setError(
                        "شما نمیتوانید در سال بیش از یکبار اقدام به فریز کردن نمایید!"
                    );
                } else if (e.hasError("OtpValidation")) {
                    setError("کد تایید وارد شده صحیح نیست");
                }
                setVerificationCodeSent(false);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    return (
        <DialogContainer>
            <DialogHeader title="فریز کردن حساب" />

            <Stack sx={{ p: 2 }} spacing={2}>
                <Typography>
                    با فریز کردن حساب کاربری شما به مدت حداکثر یک ماه فریز شده،
                    در این مدت شما قادر به استفاده از حساب کاربری خود نمیباشید.
                    بعد از پایان یک ماه و یا با فعال کردن دوباره اشتراک این مدت
                    به حساب کاربری شما بازگردانده خواهد شد.
                </Typography>

                <Divider />

                {error && <Alert severity="error">{error}</Alert>}

                {!verificationCodeSent && (
                    <LoadingButton
                        variant="contained"
                        loading={requestInProgress}
                        fullWidth
                        onClick={sendVerificationCode}
                    >
                        ارسال کد تایید
                    </LoadingButton>
                )}

                {verificationCodeSent && (
                    <>
                        <TextField
                            type="tel"
                            onChange={handleCodeChange}
                            autoComplete="one-time-code"
                            fullWidth
                            autoFocus
                            label="کد یکبار مصرف"
                        />

                        <LoadingButton
                            variant="contained"
                            loading={requestInProgress}
                            color="warning"
                            onClick={applyFreezeAccount}
                        >
                            تایید فریز شدن حساب کاربری
                        </LoadingButton>
                    </>
                )}
            </Stack>
        </DialogContainer>
    );
}
